<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction2" id="benefitAction2" type="radio" />
                        <label for="benefitAction2">{{ formLabels.fields.benefitAction2 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        formLabels: {
            type: Object,
            required: true
        }
    },
    inject: ['$v'],
    watch: {
        'formData.benefit': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
    },
    computed: {
        ...mapGetters(['formData','formSummary']),
        formConditionals: {
            get() {
                return this.$store.state.formConditionals;
            }, 
            set(value) {
                this.$store.commit('updateFormConditionals',value);
            }
        },
        benefitFields() {
            return this.formSummary[1].fields;
        }
    },
    methods: {
        setConditionals() {
            // We need to store the full object paths for use in the core form
        },
        buildSummary(fieldData) {
            let prettyLabels = {
                    action: 'Card action'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }
        },
    },
    mounted() {

        this.formSummary.push({
            fields: {}
        });
    }
}
</script>